import { render } from "./SideBar.vue?vue&type=template&id=c8654298&scoped=true"
const script = {}

import "./SideBar.vue?vue&type=style&index=0&id=c8654298&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8654298"]])

export default __exports__